/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    ROLES_title: "Privilege roles",
    ROLES_label: "role",
    ROLES_plural_label: "roles",
    ROLES_create: "Create a role",
    ROLES_edit: "Edit role",
    ROLES_back: "Back to roles",

    ROLES_columnName: "Role",
    ROLES_columnDescription: "Description",
    ROLES_columnPrivileges: "Privileges",
    ROLES_columnUpdatedBy: "Updated by",

    ROLES_fieldName: "Role name",
    ROLES_fieldNamePlaceholder: "e.g. Administrator",
    ROLES_fieldDescription: "Description",
    ROLES_fieldDescriptionPlaceholder: "What this role is for",

    ROLES_privilegesTitle: "Privileges",
    ROLES_resourcePlan: "Plan",
    ROLES_resourceCoupon: "Coupon",
    ROLES_resourceCustomer: "Customer",
    ROLES_resourceAdsPublication: "Ads publication",

    ROLES_rightRead: "Read",
    ROLES_rightUpdate: "Update",
    ROLES_rightCreate: "Create",

    ROLES_grantedCount: "No privilege | 1 privilege | {count} privileges",
    ROLES_protectedBadge: "Protected",
    ROLES_protectedRole: "This role is protected and cannot be edited.",

    ROLES_confirmCreate: "Create role",
    ROLES_save: "Save",

    ROLES_createSuccessTitle: "Role",
    ROLES_createSuccessMessage: "The role was created successfully.",
    ROLES_updated: "Role updated.",
    ROLES_updateTitle: "Role",

    ROLES_deleteConfirm: "Are you sure you want to delete this role?" +
        " | Are you sure you want to delete these roles?",
    ROLES_cannotDelete: "This role cannot be deleted.",
    ROLES_superAdminOnly: "Only a Super Admin can create or edit roles.",
    ROLES_privilegesSelected: "{n} privilege selected | {n} privileges selected",
    ROLES_fullAccessNotice: "This role has full access to every resource by default. " +
        "No privileges to configure.",

    ROLES_splashScreenTitle: "Create your first role",
    ROLES_splashScreenDescription: "A role groups the privileges granted to Console users."
};
